import React, { Component } from 'react';
import './room.css'

class RoomSelector extends Component {
  onSubmit(evnt) {
    evnt.preventDefault();
    var roomName = this.refs.roomInput.value;
    if (roomName && roomName.length > 0) {
      // Trim spaces, enforce lowercase
      roomName = roomName.toLowerCase().replace(/(^ +)|( +$)/g, '');
      this.props.onRoomSet(roomName);
    }
  }

  render() {
    return (
      <form className="room_form" onSubmit={this.onSubmit.bind(this)}>
        <input className="room_input" ref="roomInput" type="text" placeholder="Room Name" />
        <button className="room_btn">Go</button>
      </form>
    );
  }
}

export default RoomSelector;



// WEBPACK FOOTER //
// ./src/RoomSelector/RoomSelector.js